import axios from "axios";
import PAPI from "./patientsInstance";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";

export const fetchInsurances = () => {
  return PAPI.get(`/insurances/list`, {});
};

// Function to find insurance name by ID
export const findInsuranceNameById = async (insuranceId) => {
  try {
    // Fetch the insurance list
    const response = await fetchInsurances();
    const insurances = response.data; // Adjust this depending on the response structure

    // Search for the insurance by ID
    const insurance = insurances.find((item) => item.id === insuranceId);

    // Return the name if found, otherwise return a default message
    return insurance ? insurance.name : "Insurance not found";
  } catch (error) {
    console.error("Error fetching insurances:", error);
    return "Error fetching insurance list";
  }
};

export const fetchGroupInsurance = async (id) => {
  try {
    const groupId = id ? `?group_id=${id}` : "";

    const response = await axios.get(
      `${Config.patientServerUrl}/insurance-group/available-insurances${groupId}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const fetchAllInsurances = async (filter) => {
  const { account_id, location_id, page, per_page, search_term, insurance_ids, order_by } = filter;

  try {
    const searchParam = search_term ? `&search_term=${search_term}` : "";
    let insuranceIds = "";
    if (insurance_ids.length > 0) {
      insuranceIds = insurance_ids.map((id) => `&insurance_ids=${id}`).join("");
    }
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
    const response = await axios.get(
      `${Config.patientServerUrl}/insurance-group/all?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${insuranceIds}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const AddInsuranceGroup = async (data) => {
  try {
    const response = await axios.post(`${Config.patientServerUrl}/insurance-group/store`,data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const UpdateInsuranceGroup = async (data) => {
  try {
    const response = await axios.put(`${Config.patientServerUrl}/insurance-group/update`,data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteInsuranceGroup = (id, account_id, location_id) => {
  return axios.delete(
    `${Config.patientServerUrl}/insurance-group/delete/${id}?account_id=${account_id}&location_id=${location_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};

export const fetchInsuranceGroup = async () => {
  try {
    if(!userAccessToken()) return;
    const response = await axios.get(`${Config.patientServerUrl}/insurance-group/insurances`, {
      headers: {
        "Content-Type": "application/json"
      },
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};